<script>
export default {
  name: 'RtLink',
  render(h) {
    return h(
      'el-link',
      {
        class: 'rt-link',
        attrs: this.$attrs,
        props: this.$props,
        ref: 'link'
      },
      this.$slots.default
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtLink.vue?2800f6f6